<template>
  <div id="activityRegisterDetail">
    <div class="page_bd page_bd_spacing">
      <div class="weui-cells weui-cells_form">
        <template v-for="item in fieldSortInfo">
          <div class="weui-cell" :key="item.configId">
            <div class="weui-cell__hd"><label class="weui-label">{{item.fieldName}}</label></div>
            <div class="weui-cell__bd">
              <p>{{item.fieldValue}}</p>
            </div>
          </div>
        </template>
        <div class="button-sp-area">
          <a href="javascript:;" class="weui-btn weui-btn_block weui-btn_default" @click="$router.back(-1)">返回</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'activityRegisterDetail',
  data () {
    return {
      fieldSortInfo: [] // 报名字段
    }
  },
  methods: {
    getFieldSortInfo () { // 查询活动报名字段排序信息
      let self = this
      self.$fly
        .request({
          method: 'get',
          url: '/h5/star/task/enroll/query/get/field/sort/info',
          params: {
            activityId: localStorage.getItem('activityId')
          }
        })
        .then(res => {
          if (res.success) {
            self.fieldSortInfo = res.data
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  activated () { },
  mounted () {
    this.getFieldSortInfo()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  #activityRegisterDetail{
    .m-b-md{
      margin-bottom: 15px;
    }
    .page_bd {
      padding: 20px 15px;
      background-color: #fff;
      .weui-cell{
        align-items: stretch;
        .weui-label{
          color: #999;
        }
        .weui-cell__bd p{
          text-align: right;
        }
        &:before{
          display: none;
        }
      }
      .button-sp-area{
        padding-top: 70px;
        border-top: 1px solid rgba(0, 0, 0, 0.1);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/activity/register/detail.vue